import React, { useState } from 'react';
import axios from 'axios';
import { CheckCircle2, Send } from 'lucide-react';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: '', company: '', role: '', email: '', phone: '', website: '', challenge: '' };
const FIELDS = [
  ['name', 'Your name *', 'text', true], ['company', 'Organisation *', 'text', true],
  ['role', 'Your role', 'text', false], ['email', 'Email *', 'email', true],
  ['phone', 'Phone *', 'tel', true], ['website', 'Website', 'text', false]
];

export const ConsultationForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/consultation/apply`, { ...form, website: form.website || null, role: form.role || null });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail?.[0]?.msg || err.response?.data?.detail || 'Something went wrong. Please try again or email hello@yellowagency.co.uk.');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div data-testid="consult-success" className="bg-[#111114] border border-[#F5CD1B]/40 rounded-2xl p-10 text-center">
        <CheckCircle2 size={44} className="text-[#F5CD1B] mx-auto" />
        <h3 className="font-display text-2xl font-bold text-white mt-5">Application received.</h3>
        <p className="text-white/70 mt-3">Thank you. We will be in touch shortly with your questionnaire and available times.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="consult-form" className="bg-[#111114] border border-white/10 rounded-2xl p-6 md:p-10 space-y-4">
      <div className="grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, ph, type, req]) => (
          <Input key={k} data-testid={`consult-${k}-input`} type={type} required={req} placeholder={ph} value={form[k]}
            onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="bg-[#0b0b0d] border-white/15 text-white h-12" />
        ))}
      </div>
      <Textarea data-testid="consult-challenge-input" required rows={5} placeholder="Tell us about the current marketing you are doing and any issues you are facing *" value={form.challenge}
        onChange={(e) => setForm({ ...form, challenge: e.target.value })} className="bg-[#0b0b0d] border-white/15 text-white" />
      {error && <p data-testid="consult-error" className="text-red-400 text-sm">{String(error)}</p>}
      <button type="submit" disabled={loading} data-testid="consult-submit-btn" className="btn-yellow w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-md uppercase text-sm disabled:opacity-60">
        {loading ? 'Sending...' : 'Apply for my free health check'} <Send size={16} />
      </button>
      <p className="text-white/40 text-xs text-center">Online video call, up to 2 hours, in November. No selling, no obligation.</p>
    </form>
  );
};
